import { Component, OnInit } from '@angular/core';
import { ColmecCheckoutStepOrderTermsComponent } from '../colmec-checkout-step-order-terms/colmec-checkout-step-order-terms.component';
import {
  AuthService,
  PriceService,
  AvailabilityService,
  MetadataService,
  SelectedCustomerService
} from 'gung-standard';
import { FormBuilder, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { first } from 'rxjs';

@Component({
    selector: 'colmec-checkout-step-order-terms-user',
    templateUrl: './colmec-checkout-step-order-terms-user.component.html',
    styleUrls: ['./colmec-checkout-step-order-terms-user.component.scss'],
    standalone: false
})
export class ColmecCheckoutStepOrderTermsUserComponent extends ColmecCheckoutStepOrderTermsComponent {

  constructor(
    protected authService: AuthService,
    protected formBuilder: FormBuilder,
    protected datePipe: DatePipe,
    protected priceService: PriceService,
    protected availabilityService: AvailabilityService,
    protected metadataService: MetadataService,
    protected selectedCustomerService: SelectedCustomerService
  ) {
    super(
      authService,
      formBuilder,
      datePipe,
      priceService,
      availabilityService,
      metadataService,
      selectedCustomerService
    );
  }

  getLabel(): string {
    return 'DELIVERY';
  }
  
}
